import MCopyLinkButton from './MCopyLinkButton.vue';

export default MCopyLinkButton;
export { MCopyLinkButton };
